var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.9646 0.464478C11.4116 0.464478 13.4646 4.56948 13.4646 4.56948C13.4646 4.56948 11.4116 8.67448 6.9646 8.67448C2.5176 8.67448 0.4646 4.56948 0.4646 4.56948C0.4646 4.56948 2.5176 0.464478 6.9646 0.464478Z",
    stroke: "#271E4A",
    strokeOpacity: 0.5,
    strokeWidth: 0.929,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.90453 4.56946C8.91049 4.8358 8.86317 5.10065 8.76536 5.34845C8.66756 5.59625 8.52123 5.82202 8.33497 6.01249C8.14871 6.20296 7.92627 6.3543 7.68071 6.45763C7.43516 6.56095 7.17144 6.61418 6.90503 6.61418C6.63862 6.61418 6.3749 6.56095 6.12934 6.45763C5.88379 6.3543 5.66135 6.20296 5.47509 6.01249C5.28883 5.82202 5.1425 5.59625 5.04469 5.34845C4.94689 5.10065 4.89957 4.8358 4.90553 4.56946C4.90553 4.03903 5.11624 3.53032 5.49132 3.15524C5.86639 2.78017 6.3751 2.56946 6.90553 2.56946C7.43596 2.56946 7.94467 2.78017 8.31974 3.15524C8.69482 3.53032 8.90553 4.03903 8.90553 4.56946H8.90453Z",
    stroke: "#271E4A",
    strokeOpacity: 0.5,
    strokeWidth: 0.929,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.26114a66e29391b215baa53f85e6fda8.svg";
export { ForwardRef as ReactComponent };